import { render, staticRenderFns } from "./campaignTeamPlate.vue?vue&type=template&id=47a1a973&"
import script from "./campaignTeamPlate.vue?vue&type=script&lang=js&"
export * from "./campaignTeamPlate.vue?vue&type=script&lang=js&"
import style0 from "./campaignTeamPlate.vue?vue&type=style&index=0&id=47a1a973&prod&lang=scss&scope=true&"
import style1 from "./campaignTeamPlate.vue?vue&type=style&index=1&id=47a1a973&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports